import React from 'react';
import SectionTitle from '../Common/SectionTitle';

const ContactInfo = (props) => {
    const { contactBoxClass } = props;
    return (
        <div className={contactBoxClass ? contactBoxClass : 'contact-box'}>
            <SectionTitle
                sectionClass="sec-title mb-44"
                subtitleClass="sub-text new-text white-color"
                subtitle="Let's Talk"
                titleClass="title white-color"
                title="Speak With Expert Engineers."
            />
            <div className="address-box mb-24">
                <div className="address-icon">
                    <i className="fa fa-phone"></i>
                </div>
                <div className="address-text">
                    <span className="label">Phone:</span>
                    <div>
                        <a href="tel:123222-8888">+1(304)4538750</a>
                    </div>
                    <div>
                        <a href="tel:123222-8888">+1(202)8492903</a>
                    </div>
                    <div>
                        <a href="tel:123222-8888">+1(202)8492932</a>
                    </div>
                </div>
            </div>
            <div className="address-box mb-24">
                <div className="address-icon">
                    <i className="fa fa-home"></i>
                </div>
                <div className="address-text">
                    <span className="label">Email:</span>
                    <a href="mailto:support@bizu.llc">support@bizu.llc</a>
                </div>
            </div>
            <div className="address-box">
                <div className="address-icon">
                    <i className="fa fa-map-marker"></i>
                </div>
                <div className="address-text">
                    <span className="label">Address:</span>
                    <div className="desc">601 Avery Street, 26101, Parkersburg, WV, USA</div>
                    <div className="desc">1730 Rhode Island Avenue, N.W., Suite 1005, Washington D.C. 20036</div>
                </div>
            </div>
        </div>
    );

}

export default ContactInfo;